export const locale = [
  {
    parentKey: "boolean_yes",
    translations: {
      nl_BE: { translation: "Ja" },
      fr_BE: { translation: "Oui" },
      tr_TR: { translation: "Evet" },
      sh_SH: { translation: "Da" },
      sk_SK: { translation: "Áno" },
      pl_PL: { translation: "Tak" },
      en_GB: { translation: "Yes" },
      bg_BG: { translation: "Да" },
      ar_SA: { translation: "نعم" },
      ru_RU: { translation: "да" },
      es_ES: { translation: "Sí" },
      sq_AL: { translation: "Po" }
    }
  },
  {
    parentKey: "boolean_no",
    translations: {
      nl_BE: { translation: "Nee" },
      fr_BE: { translation: "Non" },
      tr_TR: { translation: "Hayır" },
      sh_SH: { translation: "Ne" },
      sk_SK: { translation: "Nie" },
      pl_PL: { translation: "Nie" },
      en_GB: { translation: "No" },
      bg_BG: { translation: "не" },
      ar_SA: { translation: "لا" },
      ru_RU: { translation: "нет" },
      es_ES: { translation: "No" },
      sq_AL: { translation: "jo" }
    }
  },
  {
    parentKey: "scale_nvt",
    translations: {
      nl_BE: { translation: "weet ik niet" },
      fr_BE: { translation: "je ne sais pas" },
      tr_TR: { translation: "bilmiyorum" },
      sh_SH: { translation: "neutralan sam" },
      sk_SK: { translation: "neviem" },
      pl_PL: { translation: "nie wiem" },
      en_GB: { translation: "I do not know" },
      bg_BG: { translation: "не зная" },
      ar_SA: { translation: "لا أعلم" },
      ru_RU: { translation: "Я не знаю" },
      es_ES: { translation: "no lo sé" },
      sq_AL: { translation: "nuk e di" },
      fa_IR: { translation: "نمیدانم" }
    }
  },
  {
    parentKey: "scale_ve",
    translations: {
      nl_BE: { translation: "helemaal akkoord ++" },
      fr_BE: { translation: "tout à fait d’accord ++" },
      tr_TR: { translation: "tamamen katılıyorum ++" },
      sh_SH: { translation: "potpuno se slažem ++" },
      sk_SK: { translation: "úplne súhlasím ++" },
      pl_PL: { translation: "całkowicie zgadzam się ++" },
      en_GB: { translation: "fully agree ++" },
      bg_BG: { translation: "изцяло съгласен ++" },
      ar_SA: { translation: "أوافق تماما ++" },
      ru_RU: { translation: "полностью согласен ++" },
      es_ES: { translation: "completamente de acuerdo ++" },
      sq_AL: { translation: "shumë dakord ++" },
      fa_IR: { translation: "++ کاملا موافقم" }
    }
  },
  {
    parentKey: "scale_e",
    translations: {
      nl_BE: { translation: "akkoord +" },
      fr_BE: { translation: "d’accord +" },
      tr_TR: { translation: "katılıyorum +" },
      sh_SH: { translation: "slažem se +" },
      sk_SK: { translation: "skôr súhlasím +" },
      pl_PL: { translation: "zgadzam się +" },
      en_GB: { translation: "agree +" },
      bg_BG: { translation: "съгласен съм +" },
      ar_SA: { translation: "أوافق +" },
      ru_RU: { translation: "согласен +" },
      es_ES: { translation: "de acuerdo +" },
      sq_AL: { translation: "dakord +" },
      fa_IR: { translation: "+ موافقم" }
    }
  },
  {
    parentKey: "scale_o",
    translations: {
      nl_BE: { translation: "niet akkoord -" },
      fr_BE: { translation: "pas d’accord -" },
      tr_TR: { translation: "katılmıyorum -" },
      sh_SH: { translation: "ne slažem se -" },
      sk_SK: { translation: "skôr nesúhlasím -" },
      pl_PL: { translation: "nie zgadzam się -" },
      en_GB: { translation: "do not agree -" },
      bg_BG: { translation: "не съм съгласен -" },
      ar_SA: { translation: "أرفض -" },
      ru_RU: { translation: "не согласен -" },
      es_ES: { translation: "en desacuerdo -" },
      sq_AL: { translation: "jo dakord -" },
      fa_IR: { translation: "- مخالفم" }
    }
  },
  {
    parentKey: "scale_vo",
    translations: {
      nl_BE: { translation: "helemaal niet akkoord --" },
      fr_BE: { translation: "absolument pas d’accord --" },
      tr_TR: { translation: "kesinlikle katılmıyorum --" },
      sh_SH: { translation: "uopće se ne slažem --" },
      sk_SK: { translation: "Vôbec nesúhlasím --" },
      pl_PL: { translation: "Całkowicie się nie zgadzam --" },
      en_GB: { translation: "do not agree at all --" },
      bg_BG: { translation: "Изцяло несъгласен --" },
      ar_SA: { translation: "أرفض إطلاقا --" },
      ru_RU: { translation: "Изцяло несъгласен --" },
      es_ES: { translation: "Completamente en desacuerdo --" },
      sq_AL: { translation: "absolutisht jo dakord --" },
      fa_IR: { translation: "-- کاملا مخالفم" }
    }
  },
  {
    parentKey: "start",
    translations: {
      nl_BE: { translation: "START" },
      fr_BE: { translation: "" },
      tr_TR: { translation: "" },
      sh_SH: { translation: "" },
      sk_SK: { translation: "" },
      pl_PL: { translation: "" },
      en_GB: { translation: "" },
      bg_BG: { translation: "" },
      ar_SA: { translation: "" },
      ru_RU: { translation: "" },
      es_ES: { translation: "" },
      sq_AL: { translation: "" }
    }
  },
  {
    parentKey: "survey_view_for_group",
    translations: {
      nl_BE: { translation: "U vult deze vragenlijst in voor" },
      fr_BE: { translation: "U vult deze vragenlijst in voor" },
      tr_TR: { translation: "U vult deze vragenlijst in voor" },
      sh_SH: { translation: "U vult deze vragenlijst in voor" },
      sk_SK: { translation: "U vult deze vragenlijst in voor" },
      pl_PL: { translation: "U vult deze vragenlijst in voor" },
      en_GB: { translation: "U vult deze vragenlijst in voor" },
      bg_BG: { translation: "U vult deze vragenlijst in voor" },
      ar_SA: { translation: "U vult deze vragenlijst in voor" },
      ru_RU: { translation: "U vult deze vragenlijst in voor" },
      es_ES: { translation: "U vult deze vragenlijst in voor" },
      sq_AL: { translation: "U vult deze vragenlijst in voor" }
    }
  },
  {
    parentKey: "disclaimer",
    translations: {
      nl_BE: { translation: "Ik ga akkoord met de privacy voorwaarden." },
      fr_BE: {
        translation: "J'accepte les conditions relatives à la vie privée."
      },
      tr_TR: {
        translation: "Özel hayatın gizliliği şartlarını kabul ediyorum."
      },
      sh_SH: { translation: "Slažem se s uvjetima privatnosti." },
      sk_SK: { translation: "S podmienkami o ochrane súkromia súhlasím." },
      pl_PL: { translation: "Zgadzam się z polityką prywatności." },
      en_GB: { translation: "I accept the privacy policy." },
      bg_BG: {
        translation: "Съгласен/съгласна съм с политиката за поверителност."
      },
      ar_SA: { translation: "أوافق على شروط الخصوصية." },
      ru_RU: { translation: "Я согласен с политикой конфиденциальности." },
      es_ES: { translation: "Acepto las condiciones de privacidad." },
      sq_AL: { translation: "Me respekt për privatësinë tuaj" },
      fa_IR: { translation: "من با شرایط حریم خصوصی موافق می‌باشم." }
    }
  },
  {
    parentKey: "disclaimer_body",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation:
          "**Met respect voor je privacy**\n\nDe vragenlijst invullen doe je vrijwillig. De gegevens van deze vragenlijst worden anoniem verwerkt. Ze worden gebruikt voor onderzoek over de samenwerking tussen school en ouders.\n\nDe resultaten kunnen enkel bekeken worden door de school en het Onderwijscentrum Gent. Individuele vragenlijsten worden binnen de drie jaar vernietigd.\n\nWe behandelen de gegevens die je invult met respect voor je privacy. We volgen hiervoor de [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nVermoed je dat iemand je persoonsgegevens onrechtmatig gebruikt? Meld het via [privacy@stad.gent](mailto:privacy@stad.gent). Je mag indien nodig ook klacht indienen bij de [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nMeer informatie over je rechten en privacy vind je [hier](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      fr_BE: {
        language: "fr_be",
        translation:
          "**Dans le respect de votre vie privée**\n\nVous participez volontairement au questionnaire. Les données de ce questionnaire seront traitées de manière anonyme. Elles seront utilisées pour des recherches sur la coopération entre l&#39;école et les parents.\n\nLes résultats ne pourront être consultés que par l&#39;école et l’Onderwijscentrum Gent (Centre éducatif de Gand).\nLes questionnaires individuels seront détruits endéans les trois ans.\n\nNous traitons les données que vous entrez dans le respect de votre vie privée.\nPour cela, nous respectons le [Règlement général sur la Protection des Données](https://www.autoriteprotectiondonnees.be/reglement-general-sur-la-protection-des-donnees-citoyen).\n\nSoupçonnez-vous que quelqu&#39;un utilise illégalement vos données personnelles ?\nSignalez-le via [privacy@stad.gent](mailto:privacy@stad.gent). Si nécessaire, vous pouvez également introduire une plainte auprès de la [Commission de surveillance flamande pour le traitement des données à caractère personnel](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nVous trouverez plus d&#39;informations sur vos droits et la protection de la vie privée [ici](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy)\n"
      },
      sh_SH: {
        language: "sh_SH",
        translation:
          "**Poštujemo Vašu privatnost**\n\nOvaj upitnik ispunjavate dobrovoljno. Podaci iz ovog upitnika obrađuju se anonimno. Koriste se za istraživanje suradnje između škole i roditelja.\n\nRezultate ovog istraživanja mogu vidjeti samo škola i Onderwijscentrum (Obrazovni centar) Gent.\nPojedinačni upitnici uništavaju se u roku od tri godine.\n\nPodatke koje unosite obrađujemo poštujući Vašu privatnost. Pri obradi podatka pridržavamo se pravila iz [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nSumnjate li da netko koristi Vaše osobne podatke na nezakonit način? \nTo prijavite putem [privacy@stad.gent](mailto:privacy@stad.gent). Ako je potrebno, možete podnijeti žalbu kod [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\n [Više informacija o Vašim pravima i privatnosti možete pronaći](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy)\n"
      },
      sk_SK: {
        language: "sk_SK",
        translation:
          "**Rešpektujeme Vaše súkromie**\n\nVyplnenie tohto dotazníka je dobrovoľné. Údaje v ňom  budú spracované anonymne a budú použité k výskumu o spolupráci medzi školou a rodičmi.\n\nK výsledkom bude mať prístup jedine škola a Onderwijscentrum Gent.\nIndividuálne dotazníky budú po troch rokoch skartované.\n\nS údajmi, ktoré vyplníte zaobchádzame s rešpektom voči Vášmu súkromiu. Dodržujeme [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nSte presvedčený/-á, že niekto Vaše osobné údaje neprávom použil? \nOznámte nám to prostredníctvom e-mailu na [privacy@stad.gent](mailto:privacy@stad.gent). Môžete tiež podať sťažnosť na [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nViac informácií o svojich právach nájdete [tu](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy)\n"
      },
      tr_TR: {
        language: "tr_TR",
        translation:
          "**Özel hayatın gizliliğine saygı**\n\nSoru listesini doldurmak gönüllülük esasına bağlıdır. Soru listesindeki veriler anonim olarak işlenir. Veriler, okul-veli işbirliğiyle ilgili yapılan araştırmada kullanılacaktır.\n\nSonuçlar sadece okul ve Onderwijscentrum Gent [Gent Eğitim Merkezi] tarafından görülebilecektir.\nBireysel soru listeleri üç yıl içerisinde yok edilecektir.\n\nDoldurduğunuz bilgileri özel yaşamın gizliliği ilkelerine saygı esasında ele alırız. Bizler bu konuda [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger) ilkelerine bağlıyız.\n\nKişisel bilgilerinizin haksız olarak kullanıldığından şüpheleniyorsanız, bunu [privacy@stad.gent](mailto:privacy@stad.gent) e-posta aracılığıyla bildirin. Gerekiyorsa [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie) (Kişisel Verilerin İşlenmesi Flaman Denetim Komisyonu) birimine de şikâyette bulunabilirsiniz.\n\nÖzel hayatın gizliliği ve haklarınıza dair daha geniş bilgi için [buraya](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy) tıklayın.\n"
      },
      es_ES: {
        language: "es_ES",
        translation:
          "**Con respeto a su privacidad**\n\nUsted completa el cuestionario de forma voluntaria. Los datos de este cuestionario se tratarán de forma anónima. Éstos serán utilizados para estudios sobre la cooperación entre la escuela y los padres de familia.\n\nLos resultados sólo podrán ser consultados por la escuela y el Onderwijscentrum Gent (Centro de Educación de Gante).\nLos cuestionarios individuales serán destruidos al cabo de tres años.\n\nTratamos los datos que usted ingresa con respeto a su privacidad. Para ello, seguimos el Reglamento correspondiente: [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\n¿Sospecha que alguien está utilizando sus datos personales de manera ilegal? Infórmelo a través de [privacy@stad.gent](mailto:privacy@stad.gent). Si le parece necesario, usted también puede presentar una queja ante la [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie) (Comisión de Supervisión flamenca para el procesamiento de datos personales).\n\nUsted encontrará más información respecto a sus derechos y a la protección de la vida privada [aquí](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      sq_AL: {
        language: "sq_AL",
        translation:
          "**Me respekt për privatësinë tuaj**\n\nJeni i lirë të plotësoni ose jo listën me pyetje. Të dhënat në këtë listë me pyetje do përpunohen në mënyrë anonime. Ato do të përdoren për të studiuar bashkëpunimin e shkollës me prindërit.\n\nRezultatet mund të shihen vetëm nga shkolla dhe Qendra e Arsimit në Gent (Onderwijscentrum Gent). Listat individuale me pyetje asgjësohen brenda 3 viteve.\n\nTë dhënat e plotësuara nga ju, ne i përpunojmë me respekt për privatësinë tuaj. Për këtë ne ndjekim Rregulloren rreth Ruajtjes së të Dhënave - [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nA keni përshtypjen se dikush i keqpërdor të dhënat tuaja? Raportojeni këtë tek [privacy@stad.gent](mailto:privacy@stad.gent). Nëse ju duket e nevojshme ju mund të depozitoni një ankesë tek Komisioni Mbikqyrës Flamand për përpunimin e të dhënave personale - [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie) (Comisión de Supervisión flamenca para el procesamiento de datos personales).\n\nMë shumë informacion rreth të drejtave dhe privatësisë I gjeni [këtu](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      bg_BG: {
        language: "bg_BG",
        translation:
          "**С уважение към Вашата поверителност**\n\nПопълването на въпросника е доброволно. Данните от настоящия списък с въпроси се обработват анонимно. Те се използват за проучване на сътрудничеството между училище и родители.\n\nРезултатите могат да бъдат видяни само от училището и Центъра за Образование Гент. Индивидуалните въпросници се унищожават в срок до три години.\n\nПо отношение на попълнените от Вас данни ние подхождаме с уважение към Вашата поверителност. За това ние следваме [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nПодозирате, че някой незаконно използва личните Ви данни? Изпратете съобщение за това на имейла [privacy@stad.gent](mailto:privacy@stad.gent). Ако е нужно, можете също така да подадете жалба, използвайки линка [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\n[Повече информация относно правата и поверителността Ви можете да намерите](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      ru_RU: {
        language: "ru_RU",
        translation:
          "**С уважением к вашей личной жизни**\n\nВы заполняете анкету добровольно. Данные из этой анкеты будут обработаны анонимно. Они используются для исследования сотрудничества между школой и родителями.\n\nРезультаты могут быть просмотрены только школой и образовательным центром Гента.По истечению трех лет индивидуальные анкеты будут уничтожены.\n\nС введенными вами данными, мы обращаемся с уважением к вашей конфиденциальности. Для этого мы следуем Общему Постановлению о Защите Данных [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nВы подозреваете, что кто-то использует вашу личную информацию незаконно? Сообщите об этом по адресу [privacy@stad.gent](mailto:privacy@stad.gent). В случае необходимости Вы также можете подать жалобу в Комиссию по надзору за обработкой персональных данных Фландрии [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nБолее подробную информацию о ваших правах и неприкосновенности частной жизни вы можете найти [здесь](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      en_GB: {
        language: "en_GB",
        translation:
          "**We respect your privacy**\n\nYou are free to fill in this questionnaire. The data from this questionnaire will be processed anonymously. It will be used to conduct research on the cooperation between schools and parents.\n\nThe results are only accessible to the school and the Onderwijscentrum Gent (Ghent Educational Centre). Individual questionnaires will be destroyed within three years.\n\nWe will handle the data you submit with respect for you privacy. We comply with the [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger) (General Data Protection Regulation - GDPR).\n\nDo you suspect someone is using your personal data unlawfully? You can file a report via [privacy@stad.gent](mailto:privacy@stad.gent). If you consider it necessary, you can also lodge a complaint with the [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie) (Flemish Supervisory Commission for the processing of personal data).\n\nMore information about your rights and privacy can be found [here](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      ar_SA: {
        language: "ar_SA",
        translation:
          "**مع االتحراا لخصوصيرك**\n\nأّث جقىً بحعبئة االسحبيبُ عِ طيب خبطش. ٍعبىجة بيبّبت هزا االسحبيبُ جحٌ بعذ إغفبه أسَبء أصحببهب، وهي ج سحخذً  ىشؤوُ اىبحد في جعبوُ اىَذسسة وأوىيبء األٍىس.\n\nال ي االسحبيبُ سىي اىَذسسة وٍشمز اىحشبية واىحعييٌ في خيْث\n\nيحٌ إجالف االسحبيبّبت اىفشدية في غضىُ ذالخ سْىات.\n[Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger) nّحِ ّحعبٍو ٍع اىبيبّبت اىحي جقىً بحعبئحهب ببححشاً ىخصىصيحل. وّحِ ّحبع ألجو هزا\n\nىذيل شنىك بأُ هْبك ٍِ يسحخذً بيبّبجل اىشخصية بطشيقة غيش ششعية؟ بّيغ عِ رىل عبش [privacy@stad.gent](mailto:privacy@stad.gent) .وإرا\n\nىزً األٍش، يَنْل أي ًضب اىحقذً بشنىي إىً [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie)\n\nالمزيد من المعلومات عِ حقىقل وعِ خصىصيحل يَنْل اىعرىس عييهب هْب [here](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy)"
      },
      fa_IR: {
        language: "fa_IR",
        translation:
          "**با رعایتِ حریم خصوصی شما**\n\nتکمیل کردن پرسشنامه داوطلبانه است. اطلاعات این پرسشنامه بدون ذکر نام در سیستم وارد و نگهداری می‌شود. ازاطلاعات برای تحقیق در مورد همکاری بین مدرسه و والدین استفاده می‌شود. \n\n نتایج فقط می‌توانند توسط مدرسه و Onderwijscentrum گنت دیده شوند. پرسشنامه‌های فردی در ظرف مدتِ سه سال از بین برده می‌شوند.\n\nما اطلاعاتی که شما پر می‌کنید را با رعایتِ حریم خصوصی‌تان وارد سیستم و نگهداری می‌کنیم. ما برای این منظور از [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger) پیروی می‌کنیم.\n\nآیا فکر ‌می‌کنید کسی اطلاعات شخصی شما را به صورت غیر قانونی استفاده می‌کند؟ این را بوسیله [privacy@stad.gent](mailto:privacy@stad.gent). اطلاع دهید. شما همچنین می‌توانید در صورت لزوم نزد [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nاطلاعات بیشتر در مورد حقوق‌ و حریم خصوصی‌تان را اینجا پیدا می‌کنید [here](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      },
      pl_PL: {
        language: "pl_PL",
        translation:
          "**Szanujemy twoją prywatność.**\n\nUczestnictwo w ankiecie jest dobrowolne. Przetwarzanie danych ankiety odbywa się anonimowo. Dane wykorzystywane są do analizy współpracy pomiędzy rodzicami, a szkołą. \n\nDostęp do wyników ma tylko szkoła lub Onderwijscentrum Gent (Centrum Edukacji Miasta Gandawy). Poszczególne kwestionariusze są niszczone w ciągu trzech lat. Danem które przekazujesz w ankiecie są przetwarzane z poszanowaniem Twojej prywatności. W tym celu stosujemy się do przepisów zawartych w ogólnym rozporządzeniu o ochronie danych  [Algemene Verordening Gegevensbescherming](https://www.gegevensbeschermingsautoriteit.be/algemene-verordening-gegevensbescherming-burger).\n\nPodejrzewasz, że ktoś nielegalnie wykorzystuje twoje dane osobowe? Zgłoś to poprzez [privacy@stad.gent](mailto:privacy@stad.gent). W razie potrzeby możesz również złożyć skargę do [Vlaamse Toezichtcommissie voor de verwerking van persoonsgegevens](https://overheid.vlaanderen.be/vlaamse-toezichtcommissie).\n\nDodatkowe informacje na temat swoich praw i prywatności znajdziesz [tutaj](https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-je-privacy).\n"
      }
    }
  },
  {
    parentKey: "register_register_title",
    translations: { nl_BE: { translation: "Registratie" } }
  },
  {
    parentKey: "register_register_body",
    translations: {
      nl_BE: {
        translation: "Om vragenlijsten uit te sturen, dient u zich eerst te registreren."
      }
    }
  },
  ,
  {
    parentKey: "register_register_group_description",
    translations: {
      nl_BE: {
        translation: "De naam van de school waarvan u de resultaten wilt bundelen. "
      }
    }
  },
  {
    parentKey: "register_register_group_enable",
    translations: { nl_BE: { translation: "Als school/groep invullen?" } }
  },
  {
    parentKey: "register_register_btn_label",
    translations: { nl_BE: { translation: "Registreren" } }
  },
  {
    parentKey: "cancel",
    translations: { nl_BE: { translation: "Annuleren" } }
  },
  {
    parentKey: "send",
    translations: { nl_BE: { translation: "versturen" } }
  },
  {
    parentKey: "register_success_title",
    translations: {
      nl_BE: { translation: "Uw gegevens zijn goed ontvangen." }
    }
  },
  {
    parentKey: "register_success_text",
    translations: {
      nl_BE: {
        translation:
          "Er werd een verificatiemail verstuurd naar het e-mailadres dat aan uw account gekoppeld is. Van zodra het emailadres is bevestigd, kan u als begeleider vragenlijsten opstarten en de resultaten na afname opvragen."
      }
    }
  },
  {
    parentKey: "validation_valueMissing",
    translations: {
      nl_BE: { translation: "Dit veld is verplicht in te vullen" }
    }
  },
  {
    parentKey: "validation_globaleMessage",
    translations: {
      nl_BE: { translation: "Niet alle velden zijn (correct) ingevuld." }
    }
  },
  {
    parentKey: "next",
    translations: { nl_BE: { language: "nl_be", translation: "Volgende" } }
  },
  {
    parentKey: "previous",
    translations: { nl_BE: { language: "nl_be", translation: "Vorige" } }
  },
  {
    parentKey: "send",
    translations: { nl_BE: { language: "nl_be", translation: "Verzend" } }
  },
  {
    parentKey: "barometer_app_link_label",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "- Deze enquête werd gemaakt met BAROMETER -"
      }
    }
  },
  {
    parentKey: "user_password_reset_title",
    translations: {
      nl_BE: { language: "nl_be", translation: "Wachtwoord vergeten?" }
    }
  },
  {
    parentKey: "user_password_reset_body",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation:
          "Vul hieronder uw e-mailadres in, we sturen u daarna een link waarmee u een nieuw wachtwoord kunt aanmaken. "
      }
    }
  },
  {
    parentKey: "user_password_reset_success",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Een email werd verzonden naar "
      }
    }
  },
  {
    parentKey: "boarding_title",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation: "Welkom op jouw BAROMETER-groepspagina"
      }
    }
  },
  {
    parentKey: "boarding_body",
    translations: {
      nl_BE: {
        language: "nl_be",
        translation:
          "Ouders en schoolteams hebben één zorg gemeenschappelijk: de zorg om het welbevinden en de ontwikkeling van elk kind. In een goed partnerschap kunnen ouders en schoolteams elkaar verrijken en versterken om het kind zo goed mogelijk te ondersteunen. \n\nDe ‘barometer samenwerking school-gezin’ is een instrument waarmee je ‘een foto neemt’ van de wijze waarop de samenwerking, de communicatie en het partnerschap tussen ouders en school verloopt. Het is géén meetinstrument waarbij je kunt nagaan of je een bepaald niveau van samenwerking school-gezin hebt behaald. Het geeft wél een beeld van hoe ouders en team op dat moment tegen de samenwerking en het partnerschap aankijken.\n\nDe barometer bestaat uit:\n\n**Voor het basisonderwijs**:\n- Een vragenlijst voor ouders\n- Een vragenlijst voor het schoolteam\n\n\n**Voor het secundair onderwijs:**\n- Een vragenlijst voor ouders\n- Een vragenlijst voor leerlingen\n-	Een vragenlijst voor het schoolteam\n\nDeze vragensets worden als geheel afgenomen. U kan ook zelf vragen toevoegen. Voor de ouders is de vragenlijst in 11 verschillende talen voorzien. \n\nNa de afname krijgt u een overzichtelijk rapport met sterktes en groeimogelijkheden waarmee u verder aan de slag kan.\n\nWilt u meer info over het partnerschap tussen ouders en scholen en hoe het Onderwijscentrum Gent hierin ondersteunt? Neem dan een kijkje op de website van Onderwijscentrum Gent:\n [https://stad.gent/onderwijscentrum-gent](https://stad.gent/onderwijscentrum-gent) "
      }
    }
  }
];
